import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  FormControl,
  Validators,
  FormGroup,
  FormBuilder,
  ReactiveFormsModule,
  FormsModule
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDatepicker,
  MatDatepickerModule
} from '@angular/material/datepicker';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule
} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { catchError, filter, Observable, of, switchMap } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import {
  LoanOptions,
  LoanReasons,
  LoanReasonsCarPool
} from 'src/app/shared/model/loanRequest.enum';
import {
  ModelList,
  LoanType,
  OrderRequest
} from 'src/app/shared/model/order.model';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { User, AuthorizerUsers } from 'src/app/shared/model/user.model';
import { Vehicles } from 'src/app/shared/model/vehicle.model';
import { HandlePermissions } from 'src/app/shared/utils/permissions';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}
@Component({
  standalone: true,
  selector: 'app-loan-request-info',
  templateUrl: './loan-request-info.component.html',
  styleUrls: ['./loan-request-info.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: 'always' }
    },
    { provide: DateAdapter, useClass: CustomDateAdapter }
  ]
})
export class LoanRequestInfoComponent implements OnInit {
  @Output() formEmitter = new EventEmitter<any>();
  @Input() user!: User;

  loanTypeEnum = Object.values(LoanOptions);
  loanReasonsEnum = LoanReasons;
  loanReasonsKeys: (keyof typeof LoanReasons)[] = Object.keys(
    LoanReasons
  ) as (keyof typeof LoanReasons)[];
  loanReasonsCPEnum = LoanReasonsCarPool;
  loanReasonsCPKeys: (keyof typeof LoanReasonsCarPool)[] = Object.keys(
    LoanReasonsCarPool
  ) as (keyof typeof LoanReasonsCarPool)[];
  placeholder = i18next.t('selectReason');
  driverType = '';
  modelList?: ModelList[];
  loanData!: LoanType;
  loanOrderType = '';
  requestObj!: OrderRequest;
  searchControl = new FormControl('', [Validators.minLength(3)]);
  searchNameControl = new FormControl('', [Validators.minLength(3)]);
  filteredOptions: Observable<User[]> = of([]);
  filteredContractOptions: Observable<User[]> = of([]);
  fullNameControl = false;
  nisControl = false;
  isSelected = false;
  controller?: AuthorizerUsers;
  authorizer?: AuthorizerUsers;
  requestTypeEnum = RequestType;
  selectedModel?: ModelList;
  totalDays = 0;
  loanType = '';
  center = '';
  deliveryDate?: Date;
  returnDate?: Date;
  minDate: string;
  minDateWeddings: string;
  maxDateCarpool: string;
  stockVehicle?: Vehicles;
  stockVin = false;
  stockModel = false;
  deliveredDate!: string;
  returnedDate!: string;
  isChecked!: boolean;
  returnDateString?: '';
  /* loan options */
  loanOptions = LoanOptions;
  disableCarpool = false;
  disableLongDuration = false;
  disableWedding = false;
  fullName = '';
  fullNameContract = '';

  /* errors */
  showError = false;
  typeError = false;
  deliveryDateError = false;
  returnDateError = false;
  driverTypeError = false;
  reasonError = false;
  reasonText = false;
  modelError = false;
  externInfoError = false;
  internInfoError = false;
  nisError = false;
  nisErrorLength = false;
  nameError = false;
  driverLicenseError = false;
  moreThanOneVehicleError = false;
  moreThanOneVehicle = false;
  noNameError = false;
  moreThan14days = false;
  authorizerError = false;
  centerError = false;
  nisErrorContract = false;
  nisErrorLengthContract = false;
  nameErrorContract = false;
  noNameErrorContract = false;
  isSelectedContract = false;
  enableCheckboxLicense = false;
  errorNisName = false;
  errorNisNameContract = false;
  errorSearch = false;
  nisComplete = false;
  errorSearchContract = false;
  nisCompleteContract = false;
  nisOK = false;
  nisOKContract = false;

  /* Selector de horas */
  hoursMinutes: string[] = [];
  selectedHour = '';
  actualHour!: string;
  today = new Date();

  form: FormGroup = this.fb.group({});
  driverForm: FormGroup = this.fb.group({});

  @ViewChild('deliveryPicker') deliveryPicker!: MatDatepicker<any>;
  @ViewChild('returnPicker') returnPicker!: MatDatepicker<any>;

  constructor(
    private fb: FormBuilder,
    private vehiclesService: VehiclesService,
    private userService: UserService,
    private route: ActivatedRoute,
    private permisision: HandlePermissions
  ) {
    const today = new Date();
    const nextMonth = new Date();
    nextMonth.setDate(today.getDate() + 30);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Si hoy es viernes (5), saltar al lunes (sumando 3 días)
    if (tomorrow.getDay() === 5) {
      tomorrow.setDate(tomorrow.getDate() + 3);
    }
    // Si hoy es sábado (6), saltar al lunes (sumando 2 días)
    else if (tomorrow.getDay() === 6) {
      tomorrow.setDate(tomorrow.getDate() + 2);
    }

    this.minDate = this.formatDate(today);
    this.minDateWeddings = this.formatDate(nextMonth);
    this.maxDateCarpool = this.formatDate(tomorrow);
  }

  ngOnInit(): void {
    this.disableCarpool = !this.permisision.getPermission('LOAN_CAR_POOL');
    this.disableWedding = !this.permisision.getPermission('LOAN_WEDDING');
    this.disableLongDuration =
      !this.permisision.getPermission('LOAN_LONG_TERMS');
    this.vehiclesService.getStockModels().subscribe({
      next: (resp: ModelList[]) => {
        return (this.modelList = resp);
      }
    });
    this.initForm();
    if (!this.disableLongDuration) {
      this.form.patchValue({ loanType: this.loanOptions.LD });
    } else if (this.disableLongDuration && !this.disableCarpool) {
      this.form.patchValue({ loanType: this.loanOptions.CP });
      this.enableCheckboxLicense = true;
    } else {
      this.form.patchValue({ loanType: this.loanOptions.W });
    }
    this.moreThanOneVehicleLogic();
    this.generateHours();
    this.initDriverForm();
  }

  generateHours() {
    for (let i = 0; i < 24; i++) {
      const hours = i < 10 ? '0' + i : i.toString();
      this.hoursMinutes.push(hours + ':00');
      this.hoursMinutes.push(hours + ':30');
    }
    const actualHour = new Date().getHours();
    const actualMinutes = new Date().getMinutes();
    if (actualHour < 10 && actualMinutes < 10) {
      this.actualHour = `0${actualHour}:0${actualMinutes}`;
    } else if (actualHour < 10 && actualMinutes > 10) {
      this.actualHour = `0${actualHour}:${actualMinutes}`;
    } else if (actualHour > 10 && actualMinutes < 10) {
      this.actualHour = `${actualHour}:0${actualMinutes}`;
    } else {
      this.actualHour = `${actualHour}:${actualMinutes}`;
    }
  }

  getAutocomplete() {
    this.filteredOptions = this.searchControl.valueChanges.pipe(
      filter(() => !this.nisOK),
      switchMap((value) =>
        value!.length >= 3
          ? this.userService.getUsersName(value!).pipe(
              catchError(() => {
                this.isSelected = false;
                this.errorSearch = true;
                this.nameError = true;
                return of([]);
              }),
              switchMap((users) => {
                this.errorSearch = false;
                this.isSelected = false;

                if (users.length === 0 && !this.isSelected) {
                  //Si no hay usuarios que coincidan con la busqueda
                  this.nameError = true;
                  this.noNameError = false;
                  return of(users);
                } else if (
                  users.length > 0 &&
                  !this.isSelected &&
                  this.fullName !== this.searchControl.value
                ) {
                  this.noNameError = true;
                  this.nameError = false;
                  return of(users);
                } else {
                  this.nameError = false;
                  this.noNameError = false;
                  return of(users);
                }
              })
            )
          : of([])
      )
    );
  }

  getAutocompleteContracting() {
    this.filteredContractOptions = this.searchNameControl.valueChanges.pipe(
      filter((value) => !!value && value.length >= 3 && !this.nisOKContract),
      switchMap((value) =>
        value!.length >= 3
          ? this.userService.getUsersName(value!).pipe(
              catchError(() => {
                this.isSelectedContract = false;
                this.errorSearchContract = true;
                this.nameErrorContract = true;
                return of([]);
              }),
              switchMap((users) => {
                this.errorSearchContract = false;
                this.isSelectedContract = false;

                if (users.length === 0 && !this.isSelectedContract) {
                  //Si no hay usuarios que coincidan con la busqueda
                  this.nameErrorContract = true;
                  this.noNameErrorContract = false;
                  return of(users);
                } else if (
                  users.length > 0 &&
                  !this.isSelectedContract &&
                  this.fullNameContract !== this.searchNameControl.value
                ) {
                  this.noNameErrorContract = true;
                  this.nameErrorContract = false;
                  return of(users);
                } else {
                  this.nameErrorContract = false;
                  this.noNameErrorContract = false;
                  return of(users);
                }
              })
            )
          : of([])
      )
    );
  }

  moreThanOneVehicleLogic() {
    this.route.queryParams.subscribe((params) => {
      this.initForm();
      this.searchControl.reset();
      this.searchNameControl.reset();
      this.moreThanOneVehicle = params['moreThanOneVehicle'];
      if (this.moreThanOneVehicle) {
        this.form.patchValue({
          loanType: this.loanOptions.LD
        });
        this.form = this.form;
        this.disableOtherLoanTypes();
      }
    });
  }

  checkLoanType() {
    return (
      this.form.value.loanType === this.loanOptions.LD ||
      this.moreThanOneVehicle
    );
  }

  initForm(): void {
    this.getAutocompleteContracting();

    if (this.form.value.loanType === this.loanOptions.CP) {
      this.form = this.fb.group({
        loanType: [this.loanOptions.CP, [Validators.required]],
        center: ['', [Validators.required]],
        deliveryDate: ['', [Validators.required]],
        returnDate: ['', [Validators.required]],
        deliveryHour: ['', [Validators.required]],
        returnHour: ['', [Validators.required]],
        reason: ['', [Validators.required]],
        reasonText: ['', [Validators.required]],
        driverType: ['', [Validators.required]],
        moreThanOneVehicle: [false]
      });
    } else if (this.form.value.loanType === this.loanOptions.W) {
      this.form = this.fb.group({
        loanType: [this.loanOptions.W, [Validators.required]],
        deliveryDate: ['', [Validators.required]],
        returnDate: ['', [Validators.required]],
        deliveryHour: ['', [Validators.required]],
        returnHour: ['', [Validators.required]],
        nisContract: ['', [Validators.required]],
        fullNameContract: ['', [Validators.required]],
        driverType: ['', [Validators.required]],
        seatEmployee: [false, [Validators.required]],
        isPetitioner: [false, [Validators.required]],
        moreThanOneVehicle: [false]
      });
      this.nisAndFullNameContractControl();
    } else {
      this.form = this.fb.group({
        loanType: [this.loanOptions.LD, [Validators.required]],
        deliveryDate: ['', [Validators.required]],
        returnDate: ['', [Validators.required]],
        deliveryHour: ['', [Validators.required]],
        returnHour: ['', [Validators.required]],
        reason: ['', [Validators.required]],
        reasonText: ['', [Validators.required]],
        driverType: ['', [Validators.required]],
        moreThanOneVehicle: [false]
      });
    }
  }

  initDriverForm(): void {
    this.getAutocomplete();
    if (
      (this.form.value.driverType === 'INTERNAL' ||
        this.form.value.loanType === this.loanOptions.CP) &&
      this.form.value.loanType !== this.loanOptions.W
    ) {
      this.driverForm = this.fb.group({
        nis: ['', [Validators.required]],
        fullName: ['', [Validators.required]],
        driverLicense: [, [Validators.required]]
      });
      this.nisAndFullNameControl();
    } else if (
      this.form.value.driverType === 'INTERNAL' &&
      this.form.value.loanType === this.loanOptions.W
    ) {
      this.driverForm = this.fb.group({
        nis: ['', [Validators.required]],
        fullName: ['', [Validators.required]],
        address: ['', [Validators.required]],
        city: ['', [Validators.required]],
        postalCode: [
          '',
          [
            Validators.required,
            ,
            Validators.pattern('^[0-9]*$'),
            Validators.minLength(5),
            Validators.maxLength(5)
          ]
        ],
        driverLicense: [, [Validators.required]]
      });
    } else {
      this.driverForm = this.fb.group({
        dni: ['', [Validators.required]],
        name: ['', [Validators.required]],
        address: ['', [Validators.required]],
        city: ['', [Validators.required]],
        telephone: [
          '',
          [
            Validators.required,
            Validators.minLength(9),
            Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$')
          ]
        ],
        lastName: ['', [Validators.required]],
        postalCode: [
          '',
          [
            Validators.required,
            Validators.pattern('^[0-9]*$'),
            Validators.minLength(5),
            Validators.maxLength(5)
          ]
        ],
        email: [
          '',
          [
            Validators.required,
            Validators.pattern(
              '[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$'
            )
          ]
        ],
        driverLicense: [, [Validators.required]]
      });
    }
  }

  changeCenter() {
    if (
      this.form.controls['center']?.dirty &&
      this.form.value.loanType === 'empty' &&
      this.loanType === this.loanOptions.CP
    ) {
      this.centerError = true;
    } else {
      this.centerError = false;
    }
    this.center = this.form.value.center;
    this.updateInfo();
  }

  changeClass() {
    this.initForm();
    this.loanType = this.form.get('loanType')!.value;
    this.driverForm.reset();
    this.searchControl.setValue('');
    this.searchNameControl.setValue('');
    this.initDriverForm();
    this.nameError = false;
    this.noNameError = false;
    this.nisError = false;
    this.nisErrorLength = false;
    this.errorNisName = false;
    this.errorNisNameContract = false;

    if (
      this.form.controls['loanType'].dirty &&
      this.form.value.loanType === ''
    ) {
      this.typeError = true;
    } else {
      this.typeError = false;
    }

    this.checkAuthorizer();

    if (this.loanType === this.loanOptions.CP) {
      this.form.get('driverType')!.setValue('INTERNAL');
      this.form.get('driverType')!.disable();
    } else {
      this.form.get('driverType')!.enable();
    }

    this.updateInfo();
  }

  checkAuthorizer() {
    const loanType = this.form.value.loanType;
    this.returnDateString = '';
    if (this.loanType === this.loanOptions.CP) {
      this.returnDateString = this.form.value.deliveryDate;
    } else {
      this.returnDateString = this.form.controls['returnDate'].value;
    }

    const deliveryDateString = this.form.controls['deliveryDate'].value;

    if (
      loanType === this.loanOptions.LD &&
      this.returnDateString &&
      deliveryDateString
    ) {
      const deliveryDate = new Date(deliveryDateString);
      const returnDate = new Date(this.returnDateString);

      // Calcular la diferencia en milisegundos
      const diffTime = returnDate.getTime() - deliveryDate.getTime();

      // Convertir la diferencia a días
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 14) {
        this.moreThan14days = true;
      } else {
        this.moreThan14days = false;
      }
    } else {
      this.moreThan14days = false;
    }
  }

  changeDate(type: string) {
    if (this.form.value.loanType === this.loanOptions.CP) {
      this.form.patchValue({ returnDate: this.form.value.deliveryDate });
    }
    if (this.form.controls[type].dirty && this.form.controls[type].invalid) {
      if (type === 'deliveryDate') {
        this.deliveryDateError = true;
      } else {
        this.returnDateError = true;
      }
    } else {
      if (type === 'deliveryDate') {
        this.deliveryDateError = false;
      } else {
        this.returnDateError = false;
      }
    }

    if (
      !!this.form.value.deliveryDate &&
      !!this.form.value.deliveryHour &&
      type === 'returnDate'
    ) {
      this.form.controls['returnHour'].reset();
    }

    if (type === 'deliveryDate' && this.loanType !== this.loanOptions.CP) {
      this.form.get('returnDate')!.setValue('');
      this.form
        .get('returnDate')!
        .setValidators([
          Validators.required,
          Validators.min(this.form.controls['deliveryDate'].value)
        ]);
    }
    if (this.form.controls['deliveryDate']) {
      this.checkAuthorizer();
    }

    if (this.form.controls['returnDate']) {
      this.checkAuthorizer();
    }
    this.updateInfo();
  }

  calculateTotalDays() {
    const deliveryDate = this.form.controls['deliveryDate'].value;
    const returnDate =
      this.loanType !== this.loanOptions.CP
        ? this.form.controls['returnDate'].value
        : null;

    if (deliveryDate && returnDate) {
      const date1 = new Date(deliveryDate);
      const date2 = new Date(returnDate);
      const timeDifference = Math.abs(date2.getTime() - date1.getTime());
      this.totalDays = Math.ceil(timeDifference / (1000 * 3600 * 24));
    } else {
      this.totalDays = 0;
    }
  }

  calculateMaxDate(): string | null {
    this.deliveryDate = this.form.get('deliveryDate')!.value;
    if (!this.deliveryDate) {
      return null;
    }

    const maxDate = new Date(this.deliveryDate);
    maxDate.setDate(maxDate.getDate() + 3);

    return maxDate.toISOString().split('T')[0];
  }

  isPetitionerContracting(): void {
    this.isChecked = this.form.get('isPetitioner')!.value;

    if (this.isChecked) {
      this.form.get('nisContract')?.setValue(this.user.nis);
      this.form.get('fullNameContract')?.setValue(this.user.fullName);
      this.form.get('nisContract')?.disable({ emitEvent: false });
      this.form.get('fullNameContract')?.disable({ emitEvent: false });
    } else {
      this.form.get('nisContract')?.enable();
      this.form.get('fullNameContract')?.enable();
      this.form.get('nisContract')?.setValue('');
      this.form.get('fullNameContract')?.setValue('');
    }
  }

  changeDriverType() {
    if (
      this.form.controls['driverType'].dirty &&
      this.form.value.driverType === 'empty'
    ) {
      this.driverTypeError = true;
    } else {
      this.driverTypeError = false;
    }
    this.internInfoError = false;
    this.externInfoError = false;
    this.initDriverForm();
    this.updateInfo();
  }

  changeReason(reason: string) {
    this.form.get('reasonText')?.reset();
    if (reason === '') {
      this.placeholder = i18next.t('loanSelectReason');
    } else if (reason === 'MALFUNCTION_MAINTENANCE_ACCIDENT') {
      this.placeholder = i18next.t('loanPlatenumber');
    } else if (reason === 'BUSINESS_TRIP') {
      this.placeholder = i18next.t('loanDestination');
    } else {
      this.placeholder = i18next.t('loanReason');
    }
    this.validateReasonText();
    this.updateInfo();
  }
  changeReasonText() {
    if (
      this.form.controls['reasonText']?.dirty &&
      this.form.value.reason !== this.loanReasonsEnum.SUPPLIER_VISIT &&
      this.form.value.reasonText === ''
    ) {
      this.reasonText = true;
    } else {
      this.reasonText = false;
    }
    this.validateReasonText();
    this.updateInfo();
  }

  validateReasonText() {
    if (
      this.form.value.reason === 'SUPPLIER_VISIT' &&
      this.form.value.reasonText === null
    ) {
      this.form.get('reasonText')?.clearValidators();
      this.form.get('reasonText')?.updateValueAndValidity();
      this.reasonText = false;
    } else if (
      this.form.value.reason !== 'SUPPLIER_VISIT' &&
      this.form.value.reason !== '' &&
      !this.form.value.reasonText
    ) {
      this.reasonText = true;
    } else {
      this.reasonText = false;
      this.reasonError = false;
    }
  }

  updateInfo() {
    this.deliveredDate = new Date(this.form.value.deliveryDate).toDateString();
    this.returnedDate = new Date(this.form.value.returnDate).toDateString();
    this.calculateTotalDays();
    this.checkAuthorizer();
    this.validateReasonText();
    let formObj;
    if (
      !this.nisError &&
      !this.nisErrorLength &&
      !this.nisErrorContract &&
      !this.nisErrorLengthContract
    ) {
      const formValue = this.form.getRawValue();
      const driverFormValue = this.driverForm.getRawValue();
      formObj = {
        ...formValue,
        loanType: this.moreThanOneVehicle
          ? this.loanOptions.LD
          : this.form.get('loanType')?.value,
        driverInfo: { ...driverFormValue },
        moreThan14days: this.moreThan14days,
        totalDays: this.totalDays
      };
    } else {
      formObj = {};
    }
    this.formEmitter.emit(formObj);
  }

  updateInfoNis() {
    this.setValidateNis();
  }

  updateInfoNisContract() {
    this.setValidateNisContract();
  }

  errorMsg(input: string) {
    if (
      this.form?.controls[input]?.invalid &&
      this.form?.controls[input]?.touched
    ) {
      return 'error-message';
    } else {
      return 'info-text';
    }
  }

  errorMsgExternInfo(input: string) {
    if (
      this.driverForm?.controls[input]?.invalid &&
      this.driverForm?.controls[input]?.touched
    ) {
      return 'error-message';
    } else {
      return '';
    }
  }

  setDriver() {
    if (this.loanType === this.loanOptions.CP && !!this.loanData?.carPoolData) {
      this.loanData.carPoolData.driverData = {
        ...this.loanData.carPoolData.driverData,
        internalDriverData: {
          ...this.driverForm.value
        }
      };
    } else {
      this.loanData.longDurationData!.driverData =
        this.form.value.driverType === 'INTERNAL'
          ? {
              ...this.loanData.longDurationData!.driverData,
              internalDriverData: {
                ...this.driverForm.value
              }
            }
          : {
              ...this.loanData.longDurationData!.driverData,
              externalDriverData: {
                ...this.driverForm.value
              }
            };
    }
  }

  setValidateNis() {
    const nis = this.driverForm.get('nis')?.value;
    const name = this.driverForm.get('fullName');

    this.nisError = false;
    this.nisErrorLength = false;

    let formObj;

    if (nis && nis.length < 6 && nis.length > 0) {
      name?.disable({ emitEvent: false });
      this.nisErrorLength = true;
      this.nisError = false;
      this.errorNisName = false;
      formObj = {};
      this.formEmitter.emit(formObj);
    } else if (nis.length === 0) {
      name?.enable({ emitEvent: false });
      this.errorNisName = true;
    } else if (nis && nis.length >= 6) {
      this.userService.getUserNisName(nis).subscribe({
        next: (resp: string) => {
          if (resp) {
            this.isSelected = true;
            this.nisOK = true;
            this.driverForm.get('fullName')?.patchValue(resp);
            this.searchControl.setValue(resp);
            this.nisError = false;
            this.nisErrorLength = false;
            this.errorNisName = false;
            const formValue = this.form.getRawValue();
            const driverFormValue = this.driverForm.getRawValue();
            formObj = {
              ...formValue,
              loanType: this.moreThanOneVehicle
                ? this.loanOptions.LD
                : this.form.get('loanType')?.value,
              driverInfo: { ...driverFormValue },
              moreThan14days: this.moreThan14days,
              totalDays: this.totalDays
            };
          } else {
            this.nisError = true;
            this.errorNisName = false;
            formObj = {};
          }
          this.formEmitter.emit(formObj);
        },
        error: () => {
          this.nisError = true;
          this.nisErrorLength = false;
          this.errorNisName = false;
          formObj = {};
          this.formEmitter.emit(formObj);
        }
      });
    }
  }

  setValidateNisContract() {
    const nis = this.form.get('nisContract')?.value;
    const name = this.form.get('fullNameContract');

    this.nisErrorContract = false;
    this.nisErrorLengthContract = false;

    let formObj;

    if (nis && nis.length < 6 && nis.length > 0) {
      name?.disable({ emitEvent: false });
      this.nisErrorLengthContract = true;
      this.nisErrorContract = false;
      this.errorNisNameContract = false;
      formObj = {};
      this.formEmitter.emit(formObj);
    } else if (nis.length === 0) {
      name?.enable({ emitEvent: false });
      this.errorNisName = true;
    } else if (nis && nis.length >= 6) {
      this.userService.getUserNisName(nis).subscribe({
        next: (resp: string) => {
          if (resp) {
            this.isSelectedContract = true;
            this.nisOKContract = true;
            this.form.get('fullNameContract')?.patchValue(resp);
            this.searchNameControl.setValue(resp);
            this.nisErrorContract = false;
            this.nisErrorLengthContract = false;
            this.errorNisNameContract = false;
            const formValue = this.form.getRawValue();
            const driverFormValue = this.driverForm.getRawValue();
            formObj = {
              ...formValue,
              loanType: this.moreThanOneVehicle
                ? this.loanOptions.LD
                : this.form.get('loanType')?.value,
              driverInfo: { ...driverFormValue },
              moreThan14days: this.moreThan14days,
              totalDays: this.totalDays
            };
            if (name?.invalid) {
              name?.disable({ emitEvent: false });
            }
          } else {
            this.nisErrorContract = true;
            this.errorNisNameContract = false;
            formObj = {};
          }
          this.formEmitter.emit(formObj);
        },
        error: () => {
          this.nisErrorContract = true;
          this.nisErrorLengthContract = false;
          this.errorNisNameContract = false;
          formObj = {};
          this.formEmitter.emit(formObj);
        }
      });
    }
  }

  onSelectionAuthorizers(event: {
    controller: AuthorizerUsers;
    authorizer: AuthorizerUsers;
  }) {
    this.controller = event.controller;
    this.authorizer = event.authorizer;
  }

  disableOtherLoanTypes() {
    const loanTypeControl = this.form.controls['loanType'];
    if (loanTypeControl) {
      loanTypeControl?.disable({ emitEvent: false });
    }
  }

  nisAndFullNameControl(): void {
    const nis = this.driverForm.get('nis');
    const name = this.driverForm.get('fullName');

    this.driverForm.get('nis')?.valueChanges.subscribe((value) => {
      if (value && value.length > 0 && !this.isSelected && !this.nisComplete) {
        this.setValidateNis();
        name?.disable();
        this.driverForm.get('fullName')?.patchValue('');
        this.errorNisName = false;
      } else if (!value) {
        this.nisError = false;
        this.nisErrorLength = false;
        this.errorNisName = true;
        name?.enable();
        this.nisOK = false;
        this.isSelected = false;
      }
    });

    this.searchControl.valueChanges.subscribe((value) => {
      if (value && value.length > 0 && !this.isSelected) {
        nis?.disable({ emitEvent: false });
        this.driverForm.get('nis')?.patchValue('');
        this.nisComplete = false;
        this.errorNisName = false;
      } else if (!value) {
        this.nameError = false;
        this.noNameError = false;
        this.errorNisName = true;
        this.nisComplete = false;
        nis?.enable();
        this.driverForm.get('nis')?.patchValue('');
      }
    });
  }

  nisAndFullNameContractControl(): void {
    const nis = this.form.get('nisContract');
    const name = this.form.get('fullNameContract');

    this.form.get('nisContract')?.valueChanges.subscribe((value) => {
      if (
        value &&
        value.length > 0 &&
        !this.isSelectedContract &&
        !this.nisCompleteContract
      ) {
        this.setValidateNisContract();
        name?.disable();
        this.form.get('fullNameContract')?.patchValue('');
        this.errorNisNameContract = false;
      } else if (!value) {
        this.nisErrorContract = false;
        this.nisErrorLengthContract = false;
        this.errorNisNameContract = true;
        name?.enable();
        this.nisOKContract = false;
        this.isSelectedContract = false;
      }
    });

    this.searchNameControl.valueChanges.subscribe((value) => {
      if (value && value.length > 0 && !this.isSelectedContract) {
        nis?.disable({ emitEvent: false });
        this.form.get('nisContract')?.patchValue('');
        this.nisCompleteContract = false;
        this.errorNisNameContract = false;
      } else if (!value) {
        this.nameErrorContract = false;
        this.noNameErrorContract = false;
        this.errorNisNameContract = true;
        this.nisCompleteContract = false;
        nis?.enable();
        this.form.get('nisContract')?.patchValue('');
      }
    });
  }

  onOptionSelected(event: any): void {
    this.nameError = false;
    this.isSelected = true;
    this.noNameError = false;
    const selectedUserName = event.option.value.fullName;
    const selectedUserNis = event.option.value.id;
    this.driverForm.get('fullName')?.patchValue(selectedUserName);
    this.driverForm
      .get('nis')
      ?.patchValue(selectedUserNis, { emitEvent: true });
    this.driverForm.get('nis')?.disable({ emitEvent: false });
    this.driverForm.get('fullName')?.enable();
    this.searchControl.setValue(selectedUserName);
    this.nisAndFullNameControl();
    this.setValidateNis();
    this.fullName = selectedUserName;
    this.nisComplete = true;
  }

  onOptionContractingSelected(event: any): void {
    this.nameErrorContract = false;
    this.isSelectedContract = true;
    this.noNameErrorContract = false;
    const selectedUserName = event.option?.value.fullName;
    const selectedUserNis = event.option?.value.id;
    this.form.get('fullNameContract')?.patchValue(selectedUserName);
    this.form
      .get('nisContract')
      ?.patchValue(selectedUserNis, { emitEvent: true });
    this.form.get('nisContract')?.disable({ emitEvent: false });
    this.form.get('fullNameContract')?.enable();
    this.searchNameControl.setValue(selectedUserName);
    this.nisAndFullNameContractControl();
    this.setValidateNisContract();
    this.fullNameContract = selectedUserName;
    this.nisCompleteContract = true;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  close() {
    if (this.loanType !== this.loanOptions.CP) {
      this.deliveryPicker['_destroyOverlay']();
      this.returnPicker['_destroyOverlay']();
    } else {
      this.deliveryPicker['_destroyOverlay']();
    }
  }
}
